import { GridColDef } from '@mui/x-data-grid-premium'

const catClass: GridColDef = {
	field: 'productClass.catClass',
	headerName: 'CATCLASS #',
	width: 150,
	sortable: false,
	valueGetter: ( _value, row ) => row.productClass?.catClass ?? '',
}

export default catClass